export function buildIdSlugPath(basePath, id, title) {
  const slug = slugify(title || '');
  if (!slug) {
    return `${basePath}/${id}`;
  }
  return `${basePath}/${id}/${slug}`;
}

export function getLandingSlugSegment(data) {
  let slugSegment = '';
  const slugFromApi = data?.slug;

  if (typeof slugFromApi === 'string') {
    const segments = slugFromApi.replace(/^\/+|\/+$/g, '').split('/');
    slugSegment = segments[segments.length - 1] || '';
  }

  if (!slugSegment) {
    slugSegment = slugify(data?.titulo || data?.nombre || '');
  }

  return slugSegment;
}

export function slugify(str) {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  const from = 'åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;';
  const to = 'aaaaaaeeeeiiiioooouuuunc------';

  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str
    .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-') // collapse dashes
    .replace(/^-+/, '') // trim - from start of text
    .replace(/-+$/, ''); // trim - from end of text

  return str;
}
